import { render, staticRenderFns } from "./TelegramChatbot.vue?vue&type=template&id=64b183f2&scoped=true"
import script from "./TelegramChatbot.vue?vue&type=script&lang=js"
export * from "./TelegramChatbot.vue?vue&type=script&lang=js"
import style0 from "./TelegramChatbot.vue?vue&type=style&index=0&id=64b183f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b183f2",
  null
  
)

export default component.exports